import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Deal } from 'app/models/dto/deal.model';
import { MatDialog } from '@angular/material/dialog';
import {
  ChangeAssignmentSmartComponent
} from 'ng2-app/borrower-header/change-assignment-smart/change-assignment-smart.component';

@Component({
  selector: 'app-deal-owner',
  templateUrl: './deal-owner.component.html',
  styleUrls: ['./deal-owner.component.scss'],
  standalone: false
})
export class DealOwnerComponent {

  @Output() updateOwner = new EventEmitter();
  @Output() loadOwner = new EventEmitter();
  @Input() ownerId: number;
  @Input() deal: Deal;
  @Input() canManageDeals: boolean;
  @Input() loading: boolean;
  @Input() readOnly: boolean = false;
  @Input() advancedDeal: boolean = false;

  editDealOwnerForm = new UntypedFormGroup({});
  fields: FormlyFieldConfig[] = [];
  model = {};
  editing = false;

  constructor(
    private dialog: MatDialog,
  ) { }

  openDialog() {
    this.dialog.open( ChangeAssignmentSmartComponent, {
      data: {
        deal: this.deal,
        type: 'deal',
      }
    });
  }
}
